import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { API_GUEST_PHOTOS } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import * as R from 'ramda';
import { updateGuest } from '../module';
import { GuestDetails } from '../guestDetails';


const KEY_ACTION = ACTION_TYPE.GET_GUEST_PHOTO_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_GUEST_PHOTO_REQUEST,
  ACTION_TYPE.GET_GUEST_PHOTO_RESPONSE,
  ACTION_TYPE.GET_GUEST_PHOTO_ERROR,
];


export const getGuestPhotoAction = (
  guest: GuestDetails,
  cloudinaryUrl: string | undefined,
  imageSize: 'large' | 'small',
) => makeApiAction(
  {
    method:   'GET',
    endpoint: API_GUEST_PHOTOS + '?url=' + (cloudinaryUrl || ''),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({
      type: action,
      meta: { guest, imageSize: imageSize },
    })) as RsaaTypes,
    bailout:  state => !cloudinaryUrl
                       || !!getLoading(state, guest.masterGuestId, KEY_ACTION)
                       || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<string> = (state, action, error, isLoading, payload) => {
  const metaGuest = action.meta.guest;
  const guestId   = metaGuest.masterGuestId;
  const imageSize = action.meta.imageSize;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error, { guest: metaGuest });
  }

  const noErrorLoading = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return updateGuest(
    noErrorLoading,
    guestId,
    (guest: GuestDetails) => {
      // If we know what image size we just got, set it specifically
      if (imageSize) {
        const prop = imageSize === 'large' ? 'imgLarge' : 'imgSmall';
        return R.assocPath([ 'photo', prop ], payload, guest);
      }

      // Otherwise, set all image sizes to the new image data
      return R.assocPath([ 'photo', 'imgSmall' ], payload, R.assocPath([ 'photo', 'imgLarge' ], payload, guest));
    },
  );
};


export const getGuestPhotoReducer = makeApiReducer<string>(ACTIONS, KEY_ACTION, reducer);
